import axios from 'axios'

const UploadProvider = {
  upload (formData) {
    return axios.post(`${process.env.VUE_APP_API_URL || 'https://brs-api.tubtimcrm.com'}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

export default UploadProvider
